import { useQuery } from '@tanstack/react-query';

import { getUrlToBackendApi, request } from '@shared/services/api';

import { PaginationType, UserPromotionCardType, UserPromotionType } from '@types';

const USER_PROMOTIONS_REQUEST_URL = '/profile/my_lotteries';

export const GET_ALL_PROMOTIONS_QUERY_KEY = ['promotions', 'list', 'user'];

const CACHE_TIME = 60000 *  5;

type USER_PROMOTION_REQUEST_TYPE = {
	status: string;
	lotteries: UserPromotionType[];
	lottery_cards: UserPromotionCardType[];
	pagination: PaginationType;
};

export const useQueryUserPromotions = (per_page: number, page: number) => {
	return useQuery<unknown, unknown, USER_PROMOTION_REQUEST_TYPE>({
		queryKey: [GET_ALL_PROMOTIONS_QUERY_KEY, page],
		queryFn: () => {
			return request<USER_PROMOTION_REQUEST_TYPE>({
				method: 'get',
				url: getUrlToBackendApi(USER_PROMOTIONS_REQUEST_URL + '?page=' + page + '&per_page=' + per_page).href
			});
		},
		retry: false,
		staleTime: CACHE_TIME
	});
};
